// extracted by css-extract-rspack-plugin
export default {"block":"TypeBlock-module__block--fhSm5","active":"TypeBlock-module__active--SyZ14"};